module.exports = "/_next/static/images/header-mail-8a1caaddae564fbb9f165710cbbec2b0.svg";